import * as React from 'react';
import { ISimpleMobileMenuFullNodeProps, ISimpleMobileMenuFullNodeState } from './SimpleMobileMenu.types';
import { MainMenuItem } from '../MainMenu/MainMenu.types';
import { Icon } from '../Icon/icon';

export class SimpleMobileMenuFullNode extends React.Component<
  ISimpleMobileMenuFullNodeProps,
  ISimpleMobileMenuFullNodeState
> {
  private itemsToShow: number[];
  constructor(props: ISimpleMobileMenuFullNodeProps) {
    super(props);
    this.state = {
      menuIsOpen: false,
      currentOpenMenuId: null,
      toggle: false,
      itemsToShow: [],
    };
    this.itemsToShow = [];
  }
  componentDidMount() {
    var result = [];
    var parentIds = this.findSelectedItems(this.props.treeNodes.Children, result);
    this.itemsToShow = parentIds;
    this.setState({
      itemsToShow: this.itemsToShow,
    });
  }

  findObject = (arr) => {
    var result;
    for (let i = 0; i < arr.length; i++) {
      if (arr[i].PageTreeDepth && arr[i].Selected) {
        result = arr[i];
        break;
      }
      if (arr[i].Children) {
        result = this.findObject(arr[i].Children);
        if (result) break;
      }
    }
    return result;
  };
  findSelectedItems = (arr, result) => {
    for (let i = 0; i < arr.length; i++) {
      if (arr[i].PathSelected) {
        result.push(arr[i].Id);
      }
      if (arr[i].Children) {
        result = this.findSelectedItems(arr[i].Children, result);
      }
    }
    return result;
  };
  renderSubItems = (item: MainMenuItem, index: number) => {
    let otherAttr: React.HTMLAttributes<any> = {};
    let showItems = this.contains(this.state.itemsToShow, item.Id);
    if (item.Id == this.props.currentPageId) {
      otherAttr['aria-current'] = 'page';
    } else {
      otherAttr = {};
    }
    return (
      <li
        key={'item' + index}
        className={
          `simple-mobile-menu-full__subitem simple-mobile-menu-full--level` + (item.PageTreeDepth - 1).toString()
        }>
        <div
          className={`d-flex justify-content-between align-items-center ${
            item.Selected && !item.PathSelected
              ? `simple-mobile-menu-full__level` + (item.PageTreeDepth - 1).toString() + ` active`
              : ''
          }`}>
          {item.IsContainerPage ? (
            <span>{item.MenuTitle ? item.MenuTitle : item.Name}</span>
          ) : (
            <a {...otherAttr} href={item.Url}>
              {item.MenuTitle ? item.MenuTitle : item.Name}
            </a>
          )}

          {(item.HasChildren || item.HasContainerPageChildren) && (
            <button
              onClick={this.toggleSubItems}
              id={item.Id.toString()}
              aria-expanded={showItems}
              aria-label={item.Name}
              aria-controls={`subitemslevel` + (item.PageTreeDepth - 1).toString() + item.Id}
              className="simple-mobile-menu-full__button">
              <Icon
                className={`simple-mobile-menu-full__arrow simple-mobile-menu-full--arrow-level2 ${
                  showItems ? 'simple-mobile-menu-full--up-arrow' : ''
                }`}
                iconType="fontawesome/chevron-left"
              />
            </button>
          )}
        </div>
        {item.Children.length > 0 && (
          <ul
            className={`${showItems ? 'd-block' : 'd-none'}`}
            id={`subitemslevel` + (item.PageTreeDepth - 1).toString() + item.Id}>
            {item.Children.length > 0 && item.Children.map((page, i) => this.renderSubItems(page, i))}
            {item.MegaMenuShowAllLinkText && (
              <li
                className={
                  `simple-mobile-menu-full__subitem simple-mobile-menu-full--level` + item.PageTreeDepth.toString()
                }>
                <div className="d-flex justify-content-between align-items-center">
                  <a className="simple-mobile-menu-full__showalltext" href={item.Url}>
                    {item.MegaMenuShowAllLinkText}
                  </a>
                </div>
              </li>
            )}
          </ul>
        )}
      </li>
    );
  };
  toggleSubItems = (e) => {
    var currentTarget = e.currentTarget;
    var currentId = parseInt(currentTarget.id);
    if (this.contains(this.itemsToShow, currentId)) {
      this.removeItemOnce(this.itemsToShow, currentId);
    } else {
      this.itemsToShow.push(currentId);
    }
    this.setState({
      itemsToShow: this.itemsToShow,
      currentOpenMenuId: currentId + 'button',
    });
  };

  contains = (a, obj) => {
    var i = a.length;
    while (i--) {
      if (a[i] === obj) {
        return true;
      }
    }
    return false;
  };

  removeItemOnce = (arr, value) => {
    var index = arr.indexOf(value);
    if (index > -1) {
      arr.splice(index, 1);
    }
    return arr;
  };
  render() {
    return (
      <nav className="simple-mobile-menu-full" aria-label="Hierarkisk navigationsmeny för hela webbplatsen">
        <ul className="simple-mobile-menu-full__list">
          {this.props.treeNodes.Children.map((child, i) => {
            let showItems = this.contains(this.state.itemsToShow, child.Id);
            return (
              <li
                key={i}
                className={`simple-mobile-menu-full__level1 ${showItems ? 'simple-mobile-menu-full__open' : ''} ${
                  child.Selected || child.PathSelected ? 'simple-mobile-menu-full__selected' : ''
                } ${child.PathSelected ? 'path' : ''}`}>
                <div className="simple-mobile-menu-full__mainitems d-flex justify-content-between align-items-center">
                  {child.IsContainerPage ? <span>{child.Name}</span> : <a href={child.Url}>{child.Name}</a>}

                  {child.Children.length > 0 && (
                    <button
                      onClick={this.toggleSubItems}
                      id={child.Id.toString() + 'button'}
                      aria-expanded={showItems}
                      aria-label={child.Name}
                      aria-controls={'subitemsmobile' + child.Id}
                      className="simple-mobile-menu-full__button">
                      <Icon
                        className={`simple-mobile-menu-full__arrow ${
                          showItems ? 'simple-mobile-menu-full--up-arrow' : ''
                        }`}
                        iconType="fontawesome/chevron-left"
                      />
                    </button>
                  )}
                </div>

                <ul
                  key={i}
                  id={'subitemsmobile' + child.Id}
                  data-id={child.Id}
                  className={`${showItems ? 'd-flex' : 'd-none'} flex-wrap`}>
                  {child.Children.map(this.renderSubItems)}
                </ul>
              </li>
            );
          })}
        </ul>
      </nav>
    );
  }
}
